// this is an autogenerated file from DesignSystem/ManualAutomations/data.graphql
import { gql } from 'Data/Api'

export default gql`
subscription app__DesignSystem_ManualAutomations{
  events_pending_manual_action_executions_by_user {
    id
  }
}

`